import { useDispatch, useSelector } from 'react-redux'
import { logoutAction } from '../../actions/userActions'
import { authenticatedSelector } from '../../reducers/userReducer'
import { AppRootState } from '../../store/types'
import { ga4Event } from '../libs/ga4'

export default function NavBar() {
  const dispatch = useDispatch()
  const authenticated = useSelector((state: AppRootState) =>
    authenticatedSelector(state.user),
  )

  return (
    <div className="fixed bg-white top-0 left-0 right-0 z-10">
      <div className="container">
        <div className="flex flex-row justify-between self-center py-l">
          <img src="/images/aifian-logo.svg" width={101} height={28} />
          {authenticated ? (
            <span
              className="babu-text text-text500 cursor-pointer"
              onClick={() => {
                dispatch(logoutAction())
                ga4Event('slash_logout')
                setTimeout(() => {
                  window.location.reload()
                }, 10)
              }}>
              登出
            </span>
          ) : null}
        </div>
      </div>
    </div>
  )
}
